import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  field: {
    marginTop: [8, '!important']
  },
  checkbox: {
    marginTop: [18, '!important']
  }
})

export default useStyles
